import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const AdminDashboard = () => {
  const navigate = useNavigate();

  const categories = [
    "AI Study Assistants",
    "Explore AI Courses",
    "Explore YouTube Tools",
    "AI Note-Taking",
    "AI Content Ideas",
    "AI Video Editing"
  ];

  const [formData, setFormData] = useState({});
  const [files, setFiles] = useState({});
  const [existing, setExisting] = useState({});

  // Admin check
  useEffect(() => {
    if (localStorage.getItem("isAdmin") !== "true") {
      navigate("/login");
    }
  }, [navigate]);

  // Handle text input changes
  const handleChange = (i, field, value) => {
    setFormData(prev => ({
      ...prev,
      [i]: { ...prev[i], [field]: value }
    }));
  };

  // Handle file selection
  const handleFile = (i, file) => {
    setFiles(prev => ({ ...prev, [i]: file }));
  };

  // Save / update content
  const saveContent = async (i, category) => {
    try {
      const form = new FormData();
      form.append("category", category);

      // Add text fields
      if (formData[i]) {
        Object.keys(formData[i]).forEach(key => {
          form.append(key, formData[i][key]);
        });
      }

      // Add ID if existing
      if (existing[i]?._id) form.append("id", existing[i]._id);

      // Add file if selected
      if (files[i]) form.append("imageFile", files[i]);

      console.log("Sending FormData:", form);

      const res = await fetch("https://new.aitoolsbenefits.com/api/content/save", {
        method: "POST",
        body: form
      });

      const data = await res.json();
      console.log("Response:", data);
      alert(data.message || "Saved successfully");

      // Reset only subtitle, paragraph, and file
      setFormData(prev => ({
        ...prev,
        [i]: { ...prev[i], subTitle: "", paragraph: "" }
      }));
      setFiles(prev => ({ ...prev, [i]: null }));
    } catch (err) {
      console.error("Upload error:", err);
      alert("❌ Error uploading content");
    }
  };

  return (
    <div className="container py-5">
      <h2 className="text-center mb-4">Admin Dashboard</h2>

      <div className="row g-4">
        {categories.map((cat, i) => (
          <div className="col-md-6" key={i}>
            <div className="card shadow rounded-4">
              <div className="card-body">
                <h5>{cat}</h5>

                <input
                  className="form-control mb-2"
                  placeholder="Title"
                  value={formData[i]?.title || ""}
                  onChange={e => handleChange(i, "title", e.target.value)}
                />

                {/* Existing image */}
                {existing[i]?.image && !files[i] && (
                  <img
                    src={`https://new.aitoolsbenefits.com${existing[i].image}`}
                    className="img-fluid rounded mb-2"
                    alt="Existing"
                  />
                )}

                {/* Preview selected file */}
                {files[i] && (
                  <img
                    src={URL.createObjectURL(files[i])}
                    className="img-fluid rounded mb-2"
                    alt="Preview"
                  />
                )}

                <input
                  type="file"
                  className="form-control mb-2"
                  onChange={e => {
                    if (e.target.files && e.target.files[0]) {
                      handleFile(i, e.target.files[0]);
                    }
                  }}
                />

                <input
                  className="form-control mb-2"
                  placeholder="Sub Title (add only)"
                  value={formData[i]?.subTitle || ""}
                  onChange={e => handleChange(i, "subTitle", e.target.value)}
                />

                <textarea
                  className="form-control mb-3"
                  rows="3"
                  placeholder="Paragraph (add only)"
                  value={formData[i]?.paragraph || ""}
                  onChange={e => handleChange(i, "paragraph", e.target.value)}
                />

                <button
                  className="btn btn-primary w-100"
                  onClick={() => saveContent(i, cat)}
                >
                  Save / Update
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminDashboard;
